import { memo } from 'react';

import { usePermissions } from '../../hooks/usePermissions';
import type { Topic } from '../../types/api';
import { isBrowser } from '../../utils/web';
import { BookmarkTopic } from './BookmarkTopic';
import styles from './TopicListItemActions.module.scss';
import { TopicPin } from './TopicPin';

export const TopicListItemActions = memo(
  ({
    topic,
    className,
    isAuthorBlocked = false,
  }: {
    topic: Topic;
    className: string;
    isAuthorBlocked?: boolean;
  }) => {
    const { isAdmin, isModerator, authUserId } = usePermissions();
    const isPinnable = isAdmin || isModerator;
    const { pinned, isFavorite } = topic;

    // Native blocking: disable topic actions when author is blocked
    if (isAuthorBlocked) {
      return <div className={`${className} opacity-50 pointer-events-none`} />;
    }

    return (
      <div className={className}>
        {(pinned || isPinnable) && (
          <TopicPin
            className={
              (isPinnable && pinned && styles.squareAction) ||
              (isPinnable && styles.animatedAction) ||
              styles.square
            }
            id={topic.id as string}
            pinned={!!pinned}
          />
        )}

        {isBrowser && authUserId && (
          <BookmarkTopic
            className={isFavorite ? styles.squareAction : styles.animatedAction}
            id={topic.id as string}
            isFavorite={!!isFavorite}
          />
        )}
      </div>
    );
  },
);
